import { useContext, useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';

const useAuth = () => {
  const { user, getUserPermissions, loading, role } = useContext(AuthContext);
  const [userPermissions, setUserPermissions] = useState([]);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user) {
        try {
          const role = await getUserPermissions(user.uid);
          setUserPermissions(role);
        } catch (error) {
        }
      } else {
        setUserPermissions([]);
      }
    };
    
    fetchUserRole();
  }, [user, getUserPermissions]);

  return { user, userPermissions, loading };
};

export default useAuth;
